import React, {useEffect, useState} from 'react';
import axios from "axios";
import {header} from "../../../../../components/api/Header";
import {NavLink, Route, Routes, useParams} from "react-router-dom";
import Insert from "./Insert";
import Meteo from "./Meteo";
import Xisob from "./Xisob";
import Evopo from "./Evopo";
import Talab from "./Talab";
import {ExcelPrint} from "../../../../../components/functions/Print";
import excel from "../../../../../icons/excel.png";
import { getEnv } from "../../../../../lib/env";

function Fao(props) {
    const params = useParams()
    const [crops, setCrops] = useState([])
    const scrops = localStorage.getItem('sfr-fao-crops')
    const [selectedCrops, setSelectedCrops] = useState(scrops?JSON.parse(scrops):{})
    const [locations, setLocations] = useState({})
    const [year, setYear] = useState(new Date().getFullYear())
    useEffect(() => {
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/fao/all",header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res.data){
                if(res.data[0]){
                    setLocations(res.data[0])
                }
                if(res.data[1]){
                    setCrops(res.data[1])
                }
            }
        }
        fetchData()
    }, []);
    return (
        <div className="row" id="tblData">
            <div className="col-12" style={{position:"sticky",top:"-12px",zIndex:"3"}}>
                <div className="xisobotlar-menu bg-white">
                    <ul className="px-3">
                        <li><NavLink to="/sfr/fao" className={params['*'] == ''?'activ':''}>Ekin tanlash</NavLink></li>
                        <li><NavLink to="/sfr/fao/meteo" className={params['*'] == 'meteo'?'activ':''}>Meteo ma'lumotlar</NavLink></li>
                        <li><NavLink to="/sfr/fao/xisob" className={params['*'] == 'xisob'?'activ':''}>Meteo xisob</NavLink></li>
                        <li><NavLink to="/sfr/fao/evopo" className={params['*'] == 'evopo'?'activ':''}>Evapotranspiratsiya</NavLink></li>
                        <li><NavLink to="/sfr/fao/talab" className={params['*'] == 'talab'?'activ':''}>Suvga talab</NavLink></li>
                    </ul>
                    <ul>
                        <li>
                            <button className="btn p-0" onClick={()=>ExcelPrint("FAO", "sheet1","tblData")}>
                                <img src={excel} alt="404"/>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <Routes>
                <Route path="/" element={<Insert crops={crops} selectedCrops={selectedCrops} setSelectedCrops={setSelectedCrops} year={year}/>}/>
                <Route path="/meteo" element={<Meteo />}/>
                <Route path="/xisob" element={<Xisob locations={locations}/>}/>
                <Route path="/evopo" element={<Evopo selectedCrops={selectedCrops} locations={locations}/>}/>
                <Route path="/talab" element={<Talab selectedCrops={selectedCrops} locations={locations} />}/>
            </Routes>
        </div>
    );
}

export default Fao;